<template>
  <div
    class="bb-popup-log-history"
    :style="popupPosition"
  >
    <div
      class="bb-popup-log-history-item"
      v-for="({eventDescription, eventDate}, index) in details"
      :key="index"
    >
      <div
        v-if="isChange"
        class="bb-popup-log-history-item__title"
        :class="[
          index === 1 && 'bb-popup-log-history-item__title_update'
        ]"
      >
        {{index === 0 ? 'Before' : 'After'}}
      </div>
      <div class="bb-popup-log-history-item__date">
        {{dateFormat(eventDate)}}
      </div>
      <div
        class="bb-popup-log-history-item__desc"
        :class="[
          index === 0 && isChange && 'bb-popup-log-history-item__desc_update'
        ]"
      >
        {{eventDescription}}
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'PopupLogHistory',
  props: {
    details: {
      type: Array,
      default: () => ([])
    },
    popupPosition: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    isChange () {
      return this.details.length === 2
    }
  },
  methods: {
    dateFormat (eventDate) {
      return moment(eventDate).format('DD-MMM-YYYY')
    }
  }
}
</script>

<style  lang="scss" scoped>
@import "../../../sass/variables";

  .bb-popup-log-history {
    position: fixed;
    top: 100px;
    max-width: 296px;
    width: auto;
    transition: opacity 0.3s;
    border-radius: 4px;
    padding: 16px 0 16px 0;
    box-shadow: 0 0 12px rgba($color-black, 0.12);
    background: $color-white;
    z-index: 10;

    @media (max-width: 1440px) {
      max-width: 260px;
    }
  }

  .bb-popup-log-history-item {
    padding: 0 16px 0 16px;

    & + & {
      border-top: 1px solid $color-mercury;
    }

    &__title {
      margin: 0 0 8px 0;
      font-size: 13px;
      font-weight: 600;
      line-height: 16px;
      color: $color-denim;

      &_update {
        margin: 14px 0 8px 0;
      }
    }

    &__date {
      font-size: 12px;
      font-weight: 400;
      line-height: 14px;
      color: $color-gray;
      margin: 0 0 4px;
    }

    &__desc {
      font-size: 12px;
      font-weight: 400;
      line-height: 16px;
      color: $color-black;

      &_update {
        margin: 0 0 14px 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Main/PopupLogHistory/PopupLogHistory.vue